import getGlobal from './getGlobal';

/**
 * 发送ga事件
 * @param action 
 * @param dataOrTag 跟踪事件的标签,或者自定义数据
 * @param value 在 GA 中将显示为事件价值的非负整数，比如可用来统计视频的加载时间
 */
export function sendGtag(action: string, dataOrTag: object|string, value?: number): void {

    let data;
    if (typeof dataOrTag !== 'string') {

        data = dataOrTag;
    }
    else {

        data = {
            'event_category': 'engagement',
            'event_label': dataOrTag,
            'value': typeof value === 'number' ? value : undefined
        };
    }
    getGlobal().gtag?.('event', action, data);
}
